<template>
    <div :class="badgeClasses">
        <font-awesome-icon
            v-if="props.icon"
            widthAuto
            :icon="props.icon"
            :class="iconClasses"
            size="xs"
        ></font-awesome-icon>
        <span class="text-xs">
            <slot></slot>
        </span>
    </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed, type PropType } from 'vue';
import type { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import type { MetaBadgeColor } from './MetaBadge.types';

const props = defineProps({
    icon: {
        type: Object as PropType<IconDefinition>,
    },
    color: {
        type: String as PropType<
            MetaBadgeColor
        >,
        default: 'muted',
    },
});

const badgeClasses = computed(() => {
    const baseClasses = 'rounded-sm px-2 py-1 inline-flex items-center gap-1';

    const colorMap = {
        muted: 'bg-slate-50 text-slate-800',
        amber: 'bg-amber-50 text-amber-800',
        sky: 'bg-sky-50 text-sky-800',
        primary: 'bg-sky-50 text-sky-800',
        danger: 'bg-rose-50 text-red-800',
        rose: 'bg-rose-50 text-red-800',
        orange: 'bg-orange-50 text-orange-800',
        slate: 'bg-slate-50 text-slate-800',
        violet: 'bg-violet-50 text-violet-800',
        teal: 'bg-teal-50 text-teal-800',
        neutral: 'bg-blue-50 text-blue-800',
        blue: 'bg-blue-50 text-blue-800',
    };

    return `${baseClasses} ${colorMap[props.color]}`;
});

const iconClasses = computed(() => {
    const colorMap = {
        muted: 'text-slate-400',
        amber: 'text-amber-400',
        sky: 'text-sky-400',
        primary: 'text-sky-400',
        danger: 'text-rose-400',
        rose: 'text-rose-400',
        orange: 'text-orange-400',
        slate: 'text-slate-400',
        violet: 'text-violet-400',
        teal: 'text-teal-400',
        neutral: 'text-blue-400',
        blue: 'text-blue-400',
    };

    return colorMap[props.color];
});
</script>
